import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textToPossessive',
  standalone: false,
})
export class TextToPossessivePipe implements PipeTransform {
  transform(inputString = ''): string {
    return 's' === inputString.substr(-1).toLowerCase()
      ? `${inputString}'`
      : `${inputString}'s`;
  }
}
